import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Helper from '@ember/component/helper';
import { task } from 'ember-concurrency';

/*
 * This helper wraps a function in an ember-concurrency task
 * Useful when you are passing a fn to a component that expects an ember-concurrency task
 *
 * @example
 *   <ChildComponent @handleClick={{ec-task this.myFunction type="drop"}} />
 */

/**
 * @param {Function} fn   Required. The function to wrap
 * @param {String} type   Optional. The type of task. Defaults to `task`
 * @returns {Task}        Returns an ember concurrency task
 */
export default class EcTask extends Helper {
  constructor(..._args) {
    super(..._args);
    _defineProperty(this, "task", _buildTask(() => ({
      context: this,
      generator: function* (...args) {
        return yield this.handler(...args);
      }
    }), null, "task", null));
    _defineProperty(this, "dropTask", _buildTask(() => ({
      context: this,
      generator: function* (...args) {
        return yield this.handler(...args);
      }
    }), {
      drop: true
    }, "dropTask", null));
    _defineProperty(this, "restartableTask", _buildTask(() => ({
      context: this,
      generator: function* (...args) {
        return yield this.handler(...args);
      }
    }), {
      restartable: true
    }, "restartableTask", null));
    _defineProperty(this, "enqueueTask", _buildTask(() => ({
      context: this,
      generator: function* (...args) {
        return yield this.handler(...args);
      }
    }), {
      enqueue: true
    }, "enqueueTask", null));
    _defineProperty(this, "keepLatestTask", _buildTask(() => ({
      context: this,
      generator: function* (...args) {
        return yield this.handler(...args);
      }
    }), {
      keepLatest: true
    }, "keepLatestTask", null));
  }
  compute([handler], {
    type
  }) {
    this.handler = handler;
    switch (type) {
      case 'drop':
        return this.dropTask;
      case 'enqueue':
        return this.enqueueTask;
      case 'keepLatest':
        return this.keepLatestTask;
      case 'restartable':
        return this.restartableTask;
      default:
        return this.task;
    }
  }
}